import { useRegion } from "../../../lib/providers/regionProvider";
import LocationInput from "./LocationInput";
import useLocation from "../../../lib/hooks/location";

interface FilterLocationComponentProps {
}

const FilterLocationComponent: React.FC<FilterLocationComponentProps> = () => {
  const { setUserLocationInfo } = useRegion();
  const { selectedPlace, setSelectedPlace } = useLocation();


  return (
    <section className="flex flex-col items-center justify-center">
      <div className="px-4">
        <LocationInput selectedPlace={selectedPlace} setSelectedPlace={setSelectedPlace} setUpdateUserInfo={setUserLocationInfo} />
      </div>


    </section>
  );
};

export default FilterLocationComponent;